module.exports = __webpack_public_path__ + "static/media/home-m2.f30481ab.png";